export function formatDefaultRiskDate(dateStr) {
  if (!dateStr) return 'latest available date';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function getDefaultRiskColor(risk) {
  const value = (risk || '').toLowerCase();
  if (value.includes('very safe')) return '#52c41a';
  if (value.includes('low risk')) return '#73d13d';
  if (value.includes('moderate risk') || value.includes('moderate')) return '#faad14';
  if (value.includes('high risk')) return '#fa8c16';
  if (value.includes('very high risk')) return '#d4380d';
  if (value.includes('distressed')) return '#f5222d';
  if (value.includes('investment grade')) return '#73d13d';
  return '#94a3b8';
}

export function getDefaultRiskProgressPercent() {
  return 100;
}

export function getDefaultRiskChange(pdHistory) {
  if (!Array.isArray(pdHistory) || pdHistory.length < 2) return null;
  const latest = Number(pdHistory[pdHistory.length - 1]?.PD_percent ?? pdHistory[pdHistory.length - 1]?.pdPercent ?? 0);
  const prev = Number(pdHistory[pdHistory.length - 2]?.PD_percent ?? pdHistory[pdHistory.length - 2]?.pdPercent ?? 0);
  return latest - prev;
}

export function normalizeDefaultRiskData(raw) {
  if (!raw) return null;

  const pdHistory = Array.isArray(raw.pdHistory)
    ? raw.pdHistory.map((row) => ({
        tradeDate: row.tradeDate ?? row.date,
        PD_percent: row.PD_percent ?? row.pd_percent ?? row.pdPercent,
      }))
    : [];

  return {
    issuerName: raw.issuerName ?? raw.issuer,
    asOnDate: raw.asOnDate ?? raw.date,
    PD_percent: raw.PD_percent ?? raw.pd_percent ?? raw.pdPercent,
    pdHistory,
    risk: raw.risk,
    riskRange: raw.riskRange,
  };
}
